/** How long the close animation runs before the content unmounts. Matches
 *  the `--moo-duration` token the transition reads. */
export const COLLAPSE_MS = 360;
